import axios from "axios";
import { API } from "../context/AuthContext";

export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

const toDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

/** Validates, encodes, and uploads one image. Returns { id, url, kind }. */
export async function uploadListingImage(file, kind, authHeader) {
  if (!file) throw new Error("No file selected");
  if (!ALLOWED_IMAGE_TYPES.includes((file.type || "").toLowerCase())) {
    throw new Error("Only JPEG, PNG, and WebP images are supported");
  }
  if (file.size > MAX_IMAGE_BYTES) throw new Error("Image too large — 5MB max");
  const data_url = await toDataUrl(file);
  const r = await axios.post(
    `${API}/uploads/media`,
    { kind, content_type: file.type, filename: file.name, data_url },
    { headers: authHeader() }
  );
  return r.data;
}

/** Backend returns app-relative URLs (/api/media/...) — make them absolute. */
export const mediaSrc = (url) => {
  if (!url) return "";
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  const base = API.replace(/\/api$/, "");
  return url.startsWith("/api/") ? `${base}${url}` : url;
};
